module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_22.00d4492c.mp3";